import { render } from "./NNavbar.vue?vue&type=template&id=54473700"
import script from "./NNavbar.vue?vue&type=script&lang=js"
export * from "./NNavbar.vue?vue&type=script&lang=js"

import "./NNavbar.vue?vue&type=style&index=0&id=54473700&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__